import { useNavigate } from "react-router-dom";
import { Image, Flex, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H2, BodyText, Subtitle } from "src/atoms/typography";
import { SceneLayout } from "src/components/SceneLayout";
import getImageSrc from "src/utils/getImageSrc";

function Promotion({ flow, closeWizard }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <SceneLayout
        absolute={
          <Button
            variant="flatPrimary"
            borderRadius="12px"
            py="5px"
            px="14px"
            minWidth="56px"
            position="fixed"
            top="14px"
            right="10px"
            onClick={() => {
              navigate("/dashboard");
              closeWizard();
            }}
          >
            {t("buttons.skip")}
          </Button>
        }
        centerProps={{ width: "320px" }}
        center={
          <>
            <Image src={getImageSrc("holiday.svg")} width="176px" />
            <Flex
              mt="16px"
              mb="8px"
              px="16px"
              py="8px"
              bg="primaryLight"
              borderRadius="40px"
            >
              <Subtitle color="primary">
                {t("promotion.hotels.banner")}
              </Subtitle>
            </Flex>
            <H2 color="highEmphasis" textAlign="center">
              {t("promotion.hotels.title")}
            </H2>
            <BodyText mt="8px" color="mediumEmphasis" textAlign="center">
              {t("promotion.hotels.text")}
            </BodyText>
          </>
        }
        bottomProps={{ mb: "24px" }}
        bottom={
          <>
            <Button
              variant="containedPrimary"
              onClick={() => flow.push("set-up-account")}
              mt="32px"
              minWidth="120px"
            >
              {t("buttons.continue")}
            </Button>
          </>
        }
      />
    </>
  );
}

export default Promotion;
